enum CmdType {
  sendcaptchaexpress = '010001', // 인증번호 요청
  sendotpverfy = '010002', // 가입 요청
  getterms = '010010', // 제휴사정보, 약관 정보 가져오기 (통합 버전)
  gettermsdetail = '010014', // 약관 상세정보 가져오기 (통합 버전)
  checkMvnoMember = '010006', // KT 알뜰폰 체크
  checkVulnerableMember = '010015', // 취약계층 확인
}
export default CmdType;
